import React from "react";
import ReactPixel from "react-facebook-pixel";
import ReactGA from "react-ga4";

import "./App.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GlobalStyles } from "@mui/material";
import ProtectedRoute from "./routes/ProtectedRoute";
import AdminRoute from "./routes/AdminRoute";
import LandingPage from "./pages/LandingPage/LandingPage";
import AdminSpecialtyCakes from "./pages/Admin/SpecialtyCakes/SpecialtyCakesPage";
import Flavors from "./pages/Admin/Flavors/Flavors";
import Sizes from "./pages/Admin/Sizes/Sizes";
import SpecialtyCakes from "./pages/SpecialtyCakes/SpecialtyCakes";
import StandardCakes from "./pages/Admin/StandardCakes/StandardCakes";
import Cheesecakes from "./pages/Admin/Cheesecakes/Cheesecakes";
import Patisserie from "./pages/Admin/Patisserie/Patisserie";
import LoginPage from "./pages/Login";
import SignupPage from "./pages/Signup/SignupPage";
import StandardCakesPage from "./pages/StandardCakes/StandardCakesPage";
import SpecialtyCakeDetailPage from "./pages/SpecialtyCakeDetailPage/SpecialtyCakeDetailPage";
import CheesecakesPage from "./pages/Cheesecakes/CheesecakesPage";
import PatisserieListPage from "./pages/Patisserie/PatisserieListPage";
import AccessoriesPage from "./pages/Accessories/AccessoriesPage";
import GrazeBoxesPage from "./pages/GrazeBoxes/GrazeBozes";
import GrazeBoxDetailPage from "./pages/GrazeBoxes/GrazeBoxDetails/GrazeBoxDetailsPage";
import CartPage from "./pages/Cart/CartPage";
import CheckoutPage from "./pages/Checkout/Checkout";
import ScrollToTop from "./components/ScrollToTop";
import MaintenancePage from "./components/MaintenancePage";
import { useAppConfig } from "./context/AppConfigContext";
import FlavorsPage from "./pages/Flavors/FlavorsPage";

import CustomerLayout from "./layouts/CustomerLayout";
import AdminLayout from "./layouts/AdminLayout";
import CartProvider from "./context/CartContext";
import { CheckoutProvider } from "./context/CheckoutContext";
import { SnackbarAlertProvider } from "./hooks/useSnackbarAlert";
import { FastStaffProvider } from "./context/FastStaffContext";
import AdminDisclaimersPage from "./pages/Admin/Disclaimers/DisclaimerTable";
import AdminIngredientsPage from "./pages/Admin/Ingredients/AdminIngredientsPage";
import AdminAllergensPage from "./pages/Admin/AdminAllergensPage";
import AdminDietaryTagsPage from "./pages/Admin/AdminDietaryTagsPage";
import AdminSuppliersPage from "./pages/Admin/AdminSuppliersPage";
import AccessoryAdminPage from "./pages/Admin/AdminAccessories/AccessoryAdminPage";
import GrazeBoxes from "./pages/Admin/GrazeBoxes/AdminGrazeBoxesPage";
import AdminSlotManager from "./pages/Admin/AdminSlotManager";
import OrderConfirmation from "./pages/Checkout/OrderConfirmation/OrderConfirmation";
import DiscountsPage from "./pages/Admin/Discounts/DiscountsPage";
import LoyaltyMemberPage from "./pages/Admin/LoyaltyProgram/LoyaltyMembersPage";
import LoyaltyCardByToken from "./pages/Admin/LoyaltyProgram/LoyaltyCardByToken";
import EmailConfirmationPage from "./pages/Signup/EmailConfirmationPage";
import ForgotPasswordPage from "./pages/Login/ForgotPasswordPage";
import MyAccountPage from "./pages/Account/MyAccountPage";
import OrderHistoryPage from "./pages/OrderHistory/OrderHistoryPage";
import WeddingWizardPage from "./pages/Weddings/WeddingWizardPage";

import AdminHome from "./pages/Admin/AdminHome";
import AdminUpsellPage from "./pages/Admin/UpsellItems/AdminUpsellPage";
import TermsOfService from "./pages/TermsAndPrivacy/TermsOfService";
import PrivacyPolicy from "./pages/TermsAndPrivacy/PrivacyPolicy";
import RefundPolicy from "./pages/TermsAndPrivacy/RefundPolicy";
import AdminPinPage from "./pages/Admin/AdminPinPage";
import FastSwitchRoute from "./pages/Admin/FastSwitchRoute";
import AdminStoreLocationsPage from "./pages/Admin/StoreLocations/AdminStoreLocationsPage";
import ShopPage from "./pages/Shop/ShopPage";
import AdminLogsPage from "./pages/Admin/AdminLogsPage/AdminLogsPage";
import { NavbarProvider } from "./context/NavbarContext";
import CakeAttributesPage from "./pages/Admin/CakeAttributes/CakeAttributesPage";
import ContactUsPage from "./pages/ContactUs/ContactUsPage";
import FAQPage from "./pages/FAQ/FAQPage";
import AssortedDessertBoxPage from "./pages/AssortedDessertBoxes/AssortedDessertBoxPage";
import AdminBookingPage from "./pages/Admin/BookingPage/AdminBookingPage";
import AdminContactMessagesPage from "./pages/Admin/ContactMessages/AdminContactMessagesPage";
import AdminEmployeesPage from "./pages/Admin/Employees/AdminEmployeesPage";
import AdminDashboardSummary from "./pages/Admin/AdminDashboardSummary";
import UpdateInfoPage from "./pages/Login/UpdateInfoPage";
import AdminOrderForm from "./pages/Admin/OrderForm/AdminOrderForm";
import OrderEditPage from "./pages/Admin/OrderEditPage/OrderEditPage";
import SupplyItemTable from "./pages/Admin/ShoppingList/SupplyItemTable";
import ShoppingListForm from "./pages/Admin/ShoppingList/ShoppingListForm";
import DriverShoppingList from "./pages/Admin/ShoppingList/DriverChecklist/DriverShoppingList";
import DriverShoppingListSelector from "./pages/Admin/ShoppingList/DriverChecklist/DriverShoppingListSelector";
import AdminCostProfiles from "./pages/Admin/AdminCostProfiles";
import QuickCostCalculator from "./components/QuickCostCalculator";
import ShoppingListFormWrapper from "./pages/Admin/ShoppingList/ShoppingListFormWrapper";
import LegacyOrdersPage from "./pages/OrderHistory/LegacyOrdersPage";
import DraftOrdersPage from "./pages/Admin/DraftOrders/DraftOrdersPage";
import ForbiddenPage from "./pages/ForbiddenPage";
import BirthdayPartyPage from "./pages/BirthdayPartyService/BirthdayPartyPage";
import BirthdayBookingPage from "./pages/BirthdayPartyService/BirthdayBookingPage";
import BookingConfirmationPage from "./pages/BirthdayPartyService/BookingConfirmationPage";
import DecoratingLandingPage from "./pages/Classes/LandingPage/DecoratingLandingPage";
import DecoratingBookingPage from "./pages/Classes/DecoratingBookingPage";
import DecoratingConfirmationPage from "./pages/Classes/DecoratingConfirmationPage";
import AdminDecoratingClassesPage from "./pages/Admin/DecoratingClasses/AdminDecoratingClassesPage";
import WeddingOrderConfirmationPage from "./pages/Weddings/WeddingOrderConfirmationPage";

ReactPixel.init("1075690678030109");
ReactPixel.pageView();

ReactGA.initialize("G-P00KV62RCW");
ReactGA.send("pageview");

// const stripePromise = loadStripe("pk_test_szwkzwxsYnEZ6uzwIwy9cAK400C31iFiLA");
const stripePromise = loadStripe("pk_live_myMbTYkwYNqbf5co6XYh8ozz00iftMNsCr");

function App() {
  const { config, loading } = useAppConfig();

  if (loading) return null;

  if (config?.maintenanceMode?.enabled) {
    return <MaintenancePage message={config.maintenanceMode.message} />;
  } else {
    return (
      <Elements stripe={stripePromise}>
        <NavbarProvider>
          <SnackbarAlertProvider>
            <FastStaffProvider>
              <CheckoutProvider>
                <CartProvider>
                  <GlobalStyles
                    styles={{
                      body: {
                        margin: 0,
                        padding: 0,
                        boxSizing: "border-box",
                        overflowX: "hidden",
                      },
                    }}
                  />
                  <Router>
                    <ScrollToTop />
                    <Routes>
                      {/* Routes with Navbar */}
                      <Route element={<CustomerLayout />}>
                        <Route exact path="/" element={<LandingPage />} />
                        <Route exact path="/home" element={<LandingPage />} />
                        <Route exact path="/login" element={<LoginPage />} />
                        <Route path="/forbidden" element={<ForbiddenPage />} />

                        <Route
                          exact
                          path="/update-info"
                          element={<UpdateInfoPage />}
                        />
                        <Route exact path="/signup" element={<SignupPage />} />
                        <Route
                          path="/signup/confirm-email"
                          element={<EmailConfirmationPage />}
                        />
                        <Route
                          path="/forgot-password"
                          element={<ForgotPasswordPage />}
                        />

                        <Route exact path="/shop" element={<ShopPage />} />

                        <Route
                          exact
                          path="/shop/cakes/specialty-cakes"
                          element={<SpecialtyCakes />}
                        />
                        <Route
                          exact
                          path="/shop/cakes/specialty-cakes/:id"
                          element={<SpecialtyCakeDetailPage />}
                        />
                        <Route
                          exact
                          path="/shop/cakes/standard-cakes"
                          element={<StandardCakesPage />}
                        />
                        <Route
                          exact
                          path="/shop/cakes/cheesecakes"
                          element={<CheesecakesPage />}
                        />
                        <Route
                          path="/shop/patisserie"
                          element={<PatisserieListPage />}
                        />
                        <Route
                          path="/shop/accessories"
                          element={<AccessoriesPage />}
                        />
                        <Route
                          path="/shop/gifts/graze-boxes"
                          element={<GrazeBoxesPage />}
                        />
                        <Route
                          path="/shop/graze-boxes/details"
                          element={<GrazeBoxDetailPage />}
                        />
                        <Route
                          path="/shop/gifts/assorted-dessert-boxes"
                          element={<AssortedDessertBoxPage />}
                        />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/checkout" element={<CheckoutPage />} />
                        <Route
                          path="/order-confirmation/:orderId"
                          element={<OrderConfirmation />}
                        />

                        <Route path="/flavors" element={<FlavorsPage />} />

                        {/* <Route
                          path="/birthday-parties"
                          element={<BirthdayPartyPage />}
                        />
                        <Route
                          path="/birthday-party-booking"
                          element={<BirthdayBookingPage />}
                        />
                        <Route
                          path="/birthday-booking-confirmation"
                          element={<BookingConfirmationPage />}
                        /> */}

                        <Route
                          path="/classes/decorating"
                          element={<DecoratingLandingPage />}
                        />
                        <Route
                          path="/classes/decorating/book"
                          element={<DecoratingBookingPage />}
                        />
                        <Route
                          path="/classes/decorating/confirmation/:bookingId"
                          element={<DecoratingConfirmationPage />}
                        />

                        <Route
                          path="/weddings/plan"
                          element={<WeddingWizardPage />}
                        />
                        <Route
                          path="/weddings/confirmation"
                          element={<WeddingOrderConfirmationPage />}
                        />

                        <Route path="/contact" element={<ContactUsPage />} />
                        <Route path="/faqs" element={<FAQPage />} />

                        <Route path="/terms" element={<TermsOfService />} />
                        <Route path="/privacy" element={<PrivacyPolicy />} />
                        <Route
                          path="/refund-policy"
                          element={<RefundPolicy />}
                        />

                        <Route
                          path="/points/:token"
                          element={<LoyaltyCardByToken />}
                        />

                        {/* Private Routes */}
                        <Route element={<ProtectedRoute />}>
                          <Route path="/account" element={<MyAccountPage />} />

                          <Route
                            path="/order-history"
                            element={<OrderHistoryPage />}
                          />
                        </Route>
                        <Route
                          path="/legacy-orders"
                          element={<LegacyOrdersPage />}
                        />
                      </Route>

                      <Route path="/admin-pin" element={<AdminPinPage />} />

                      {/* Admin routes (without Navbar) */}
                      <Route element={<AdminRoute />}>
                        <Route element={<AdminLayout />}>
                          <Route
                            path="/admin/dashboard"
                            element={<AdminHome />}
                          />
                          <Route
                            path="/admin/logs"
                            element={<AdminLogsPage />}
                          />
                          <Route
                            path="/admin/manual-orders"
                            element={<AdminOrderForm />}
                          />
                          <Route
                            path="/admin/draft-orders"
                            element={<DraftOrdersPage />}
                          />
                          <Route
                            path="/admin/specialty-cakes"
                            element={<AdminSpecialtyCakes />}
                          />
                          <Route
                            path="/admin/standard-cakes"
                            element={<StandardCakes />}
                          />
                          <Route
                            path="/admin/cheesecakes"
                            element={<Cheesecakes />}
                          />
                          <Route
                            path="/admin/patisserie"
                            element={<Patisserie />}
                          />
                          <Route
                            path="/admin/graze-boxes"
                            element={<GrazeBoxes />}
                          />
                          <Route
                            path="/admin/accessories"
                            element={<AccessoryAdminPage />}
                          />
                          <Route
                            path="/admin/upsell-items"
                            element={<AdminUpsellPage />}
                          />
                          <Route path="/admin/flavors" element={<Flavors />} />
                          <Route path="/admin/sizes" element={<Sizes />} />
                          <Route
                            path="/admin/ingredients"
                            element={<AdminIngredientsPage />}
                          />
                          <Route
                            path="/admin/cake-attributes"
                            element={<CakeAttributesPage />}
                          />
                          <Route
                            path="/admin/disclaimers"
                            element={<AdminDisclaimersPage />}
                          />
                          <Route
                            path="/admin/allergens"
                            element={<AdminAllergensPage />}
                          />
                          <Route
                            path="/admin/dietary-tags"
                            element={<AdminDietaryTagsPage />}
                          />
                          <Route
                            path="/admin/suppliers"
                            element={<AdminSuppliersPage />}
                          />
                          <Route
                            path="/admin/stores"
                            element={<AdminStoreLocationsPage />}
                          />
                          <Route
                            path="/admin/discounts"
                            element={<DiscountsPage />}
                          />
                          <Route
                            path="/admin/slots"
                            element={<AdminSlotManager />}
                          />
                          <Route
                            path="/admin/loyalty-program"
                            element={<LoyaltyMemberPage />}
                          />
                          <Route
                            path="/admin/contact-messages"
                            element={<AdminContactMessagesPage />}
                          />
                          <Route
                            path="/admin/booking"
                            element={<AdminBookingPage />}
                          />
                          <Route
                            path="/admin/decorating-classes"
                            element={<AdminDecoratingClassesPage />}
                          />

                          <Route
                            path="/admin/employees"
                            element={<AdminEmployeesPage />}
                          />
                          <Route
                            path="/admin/business-overview"
                            element={<AdminDashboardSummary />}
                          />
                          <Route
                            path="/admin/orders/:id/edit"
                            element={<OrderEditPage />}
                          />
                          <Route
                            path="/admin/supply-items"
                            element={<SupplyItemTable />}
                          />
                          <Route
                            path="/admin/shopping-list"
                            element={<ShoppingListForm />}
                          />
                          <Route
                            path="/admin/driver-checklist"
                            element={<DriverShoppingListSelector />}
                          />
                          <Route
                            path="/admin/shopping-lists/edit/:id"
                            element={<ShoppingListFormWrapper />}
                          />

                          <Route
                            path="/admin/driver-checklist/:id"
                            element={<DriverShoppingList />}
                          />
                          <Route
                            path="/admin/cost-calculator"
                            element={<AdminCostProfiles />}
                          />
                          <Route
                            path="/admin/quick-cost-calculator"
                            element={<QuickCostCalculator />}
                          />
                        </Route>
                      </Route>
                    </Routes>
                  </Router>
                </CartProvider>
              </CheckoutProvider>
            </FastStaffProvider>
          </SnackbarAlertProvider>
        </NavbarProvider>
      </Elements>
    );
  }
}

export default App;
